export const COLLAB_PROFILE_DEMO_URL = "https://demo.arcade.software/uz3KgHLOvPgO6XsujHWv?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true";

export const SAMPLE_SENDER_NAME = "Tyler Kim";
